<template>
  <status-template
    :title="$t('title')"
    :description="$t('description')"
    :imageUrl="require(`@/assets/kyc/step_0.svg`).default"
  />
</template>
<script>
export default {
  name: 'Denied',
  components: {
    StatusTemplate: () => import('./StatusTemplate.vue')
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "title": "Não foi possível validar este recebedor",
      "description": "Você pode tentar outra vez dentro de alguns meses."
    },
    "en-US": {
      "title": "The recipient could not be validated",
      "description": "You can try again in a few months."
    }
  }
</i18n>
